<template>
  <el-container class="app">
    <el-aside width="256px" class="aside">
      <div class="brand">
        <div class="brand-title">ProxyAdmin</div>
        <div class="brand-sub">v2.4.0</div>
      </div>

      <el-menu :default-active="$route.path" :router="true" class="menu" background-color="transparent"
        text-color="#92a4c9" active-text-color="#ffffff">
        <el-menu-item index="/dashboard">
          <i class="el-icon-data-analysis" />
          <span slot="title">Dashboard</span>
        </el-menu-item>
        <el-menu-item index="/devices">
          <i class="el-icon-monitor" />
          <span slot="title">Devices</span>
        </el-menu-item>
        <el-menu-item index="/peers">
          <i class="el-icon-connection" />
          <span slot="title">Peer Devices</span>
        </el-menu-item>
        <el-menu-item index="/proxies">
          <i class="el-icon-share" />
          <span slot="title">WebShare Proxies</span>
        </el-menu-item>
        <el-menu-item index="/proxy-admin">
          <i class="el-icon-lock" />
          <span slot="title">Proxy Management</span>
        </el-menu-item>
      </el-menu>

      <div class="aside-footer">
        <el-button type="text" class="logout" @click="onLogout">
          <i class="el-icon-switch-button" />
          <span>Logout</span>
        </el-button>
      </div>
    </el-aside>

    <el-container class="content">
      <el-header class="header">
        <div class="header-left">
          <el-button class="icon-btn" type="text">
            <i class="el-icon-menu" />
          </el-button>
          <div class="page-title">{{ pageTitle }}</div>
        </div>

        <div class="header-right">
          <el-button class="icon-btn" type="text">
            <i class="el-icon-user" />
          </el-button>

          <div class="avatar">
            <img alt="Admin"
              src="https://lh3.googleusercontent.com/aida-public/AB6AXuAMuxLztUP-EyDgm1D-kzq2-DgEIupw1l-j1MeC_IUyJkErZSOKmJ-BsZ6TTPHwM4g7QKte1uGix0r2qpw3PFs_cKh_1Mqw--SZN1Rhx2piyVWLdn44nRc7PxnbOlFUx23yzUA0I7AS89oKqnobwS5XswCoxqgh4qix0IGAUSJw-R0CzJ5Oz6BWlL8r4xKVbKv5Cd-acb5NKW77pil9671xOVzD4fZKcgSpctcbV-1YvpWMmTuqo1vSl4i8GAE5vRjzpJA3EPyJfXck">
          </div>

        </div>
      </el-header>

      <el-main class="main">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { clearToken } from '../utils/auth'

export default {
  name: 'AdminLayout',
  data() {
    return {
      search: ''
    }
  },
  computed: {
    pageTitle() {
      return (this.$route && this.$route.meta && this.$route.meta.title) ? this.$route.meta.title : 'Dashboard'
    }
  },
  methods: {
    onLogout() {
      clearToken()
      this.$router.replace({ path: '/login' })
    }
  }
}
</script>

<style scoped>
.app {
  min-height: 100vh;
  background: #101622;
  color: #ffffff;
}

.aside {
  background: #111722;
  border-right: 1px solid #232f48;
  color: #92a4c9;
  display: flex;
  flex-direction: column;
}

.brand {
  height: 64px;
  padding: 0 18px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  border-bottom: 1px solid #232f48;
}

.brand-title {
  font-size: 18px;
  font-weight: 700;
  color: #ffffff;
  line-height: 1.1;
}

.brand-sub {
  margin-top: 4px;
  font-size: 12px;
  color: #92a4c9;
}

.menu {
  border-right: none;
  padding: 10px 10px 0;
}

.aside-footer {
  margin-top: auto;
  padding: 12px 14px;
  border-top: 1px solid #232f48;
}

.logout {
  width: 100%;
  color: #92a4c9;
  text-align: left;
}

.logout:hover {
  color: #f56c6c;
}

.content {
  background: transparent;
}

.header {
  height: 64px !important;
  background: #111722;
  border-bottom: 1px solid #232f48;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px !important;
}

.header-left {
  display: flex;
  align-items: center;
  gap: 10px;
}

.page-title {
  font-size: 16px;
  font-weight: 700;
}

.page-title {
  color: #ffffff;
}

.header-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.search {
  width: 260px;
}

.search-input /deep/ .el-input__inner {
  background: #232f48;
  border-color: transparent;
  color: #ffffff;
}

.search-input /deep/ .el-input__icon {
  color: #92a4c9;
}

.icon-btn {
  width: 36px;
  height: 36px;
  padding: 0;
  border-radius: 8px;
}

.icon-btn:hover {
  background: rgba(19, 91, 236, 0.08);
}

.icon-btn {
  color: #ffffff;
}

.bell {
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.dot {
  position: absolute;
  top: 2px;
  right: 1px;
  width: 8px;
  height: 8px;
  border-radius: 999px;
  background: #f56c6c;
  border: 2px solid #ffffff;
}

.dot {
  border-color: #232f48;
}

.avatar {
  width: 36px;
  height: 36px;
  border-radius: 999px;
  overflow: hidden;
  border: 1px solid #ebeef5;
  background: #dcdfe6;
}

.avatar {
  border-color: #324467;
  background: #232f48;
}

.avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.main {
  padding: 0 !important;
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/layouts/AdminLayout.vue